import { normalizeStageColor } from "../../NodeUI/colorUtils";

export { STAGE_COLOR_PRESETS, normalizeStageColor } from "../../NodeUI/colorUtils";

/** Resolved custom color for a stage, or null to use the index-based default. */
export const resolveStageColor = (stage) => normalizeStageColor(stage?.color);
